import { createSlice } from '@reduxjs/toolkit';
import { QuickFilterType } from '../../new-components/fuzzy-input/types';
import { SearchFiltersTypes } from '../../reducers/search-filters/reducer';

export interface NawyNowFilters {
  areas: QuickFilterType;
  compounds: QuickFilterType;
  developers: QuickFilterType;
}

export const initialNawyNowState: NawyNowFilters = {
  areas: { name: 'areas', type: SearchFiltersTypes.AREAS, selected: [] },
  compounds: {
    name: 'compounds',
    type: SearchFiltersTypes.COMPOUNDS,
    selected: []
  },
  developers: {
    name: 'developers',
    type: SearchFiltersTypes.DEVELOPERS,
    selected: []
  }
};

export const nawyNowSlice = createSlice({
  name: 'nawyNow',
  initialState: initialNawyNowState,
  reducers: {
    setAreas(state, action) {
      state.areas = action.payload;
    },
    setCompounds(state, action) {
      state.compounds = action.payload;
    },
    setDevelopers(state, action) {
      state.developers = action.payload;
    },
    resetFilters(state) {
      return (state = initialNawyNowState);
    }
  }
});
export const { setAreas, setCompounds, setDevelopers, resetFilters } =
  nawyNowSlice.actions;

export default nawyNowSlice.reducer;
